<template>
  <div class="my-tabs">
    <div
      class="tabItem fontCenter"
      :class="{ active: index == navIndex }"
      v-for="(item, index) in navList"
      :key="index"
      @click="tabItemTap(index)"
    >
      {{ item.text }}
      <span v-if="item.num!= null && isShowNum ">({{item.num }})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabs",
  model: {
    prop: "navIndex",
    event: "update:navIndex",
  },
  props: {
    navList: {},
    navIndex: {},
    isShowNum: {
      default() {
        return true;
      },
    },
  },
  methods: {
    tabItemTap(i) {
      this.$emit("update:navIndex", i);
    },
  },
};
</script>

<style lang="scss" scoped>
.my-tabs {
  width: 100%;
  height: 43px;
  box-sizing: border-box;

  font-size: 13px;
  background-color: #fff;
  color: #979797;
  display: flex;
  padding: 0 15px;
  .tabItem {
    flex: 1;
    text-align: center;
    height: 100%;
    border-bottom: 1px solid #d8d8d8;
  }
  .active {
    color: #333333;
    border-bottom: 3px solid #0286ff;
  }
}
</style>
